import { Link } from 'react-router-dom'

export default function UnderReviewPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-[var(--color-surface)] rounded-2xl border border-[var(--color-border)] shadow-sm p-8 text-center">
        <div className="mx-auto w-12 h-12 rounded-full bg-[var(--color-warning-bg)] flex items-center justify-center mb-4">
          <svg className="w-6 h-6 text-[var(--color-warning)]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h1 className="text-xl font-bold text-[var(--color-text)]">Sua solicitação está em análise</h1>
        <p className="mt-2 text-[var(--color-text-muted)]">
          Enviamos um e-mail para o administrador com os detalhes da sua solicitação.
          Assim que for aprovada, você poderá fazer login e acessar o sistema.
        </p>

        <div className="mt-6 rounded-lg bg-[var(--color-surface-subtle)] p-4 text-left text-sm text-[var(--color-text-muted)]">
          <p className="mb-2 font-medium text-[var(--color-text)]">O que acontece agora?</p>
          <p>• Administrador recebe um e-mail com link de aprovação</p>
          <p>• Após aprovação, você recebe um e-mail de boas-vindas</p>
          <p>• Links de aprovação/rejeição são válidos por <strong>24 horas</strong></p>
        </div>

        <div className="mt-6 flex flex-col gap-3">
          <Link
            to="/login"
            className="w-full rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)] px-3 py-2 text-sm font-medium text-[var(--color-text)] hover:bg-[var(--color-surface-subtle)] transition-colors"
          >
            Fazer login (se já tem conta aprovada)
          </Link>

          <Link
            to="/register"
            className="w-full rounded-lg bg-[var(--color-brand-500)] px-3 py-2 text-sm font-medium text-white hover:bg-[var(--color-brand-600)] transition-colors"
          >
            Criar nova conta
          </Link>
        </div>
      </div>
    </div>
  )
}
